import { OwcButton, OwcComponentFooter, OwcComponentHeader, OwcTypography } from '@one/react';
import { Trans, useTranslation } from 'core/i18n';
import { useNativeBackButton } from 'core/platform/use-native-back-button.hook';
import {
  InactivityWarningBody,
  InactivityWarningFooter,
  InactivityWarningLayout,
} from './inactivity-warning-dialog.style';

interface InactivityWarningDialogProps {
  open: boolean;
  secondsLeft: number;
  onCancel: VoidFunction;
  onLogout: VoidFunction;
}

export const InactivityWarningDialogComponent: React.FC<InactivityWarningDialogProps> = ({
  open,
  secondsLeft,
  onCancel,
  onLogout,
}) => {
  const { t } = useTranslation('common');
  useNativeBackButton(onCancel, open);

  return (
    <InactivityWarningLayout visible={open} size="small" disableBackdropClick disableEscapeKeydown>
      <OwcComponentHeader slot="header">
        <OwcTypography variant="title6" mode="bold">
          {t('components.inactivity-warning.title')}
        </OwcTypography>
      </OwcComponentHeader>
      <InactivityWarningBody>
        <OwcTypography variant="body1" mode="regular" role="timer">
          <Trans
            t={t}
            ns="common"
            i18nKey="components.inactivity-warning.message"
            count={secondsLeft}
            components={{ bold: <strong /> }}
          />
        </OwcTypography>
      </InactivityWarningBody>
      <OwcComponentFooter slot="footer">
        <InactivityWarningFooter slot="suffix">
          <OwcButton variant="secondary" onClick={onLogout}>
            {t('components.inactivity-warning.logout')}
          </OwcButton>
          <OwcButton variant="primary" onClick={onCancel}>
            {t('components.inactivity-warning.cancel')}
          </OwcButton>
        </InactivityWarningFooter>
      </OwcComponentFooter>
    </InactivityWarningLayout>
  );
};
